import React, { Component } from "react";
import styled from "styled-components";
import axios from "axios";
import { API_URL } from "../constants";
import {
  PageWrapper,
  FormikForm,
  SelectBox,
  Button,
  TextField,
  XXLText,
  Header,
  Modal,
  FlexWrapper,
  Toast
} from "../components";
import { Formik, Field } from "formik";
import "react-table/react-table.css";
import { get, values } from "lodash";

class UpdatePurchaseProducts extends Component {
  state = {
    zipCode: "",
    loader: false,
    products: [],
    stores: [],
    product: {},
    store: {},
    selectedOption: {},
    isLoading: false,
    productPriceOriginal: null,
    userReceiptProductDetail: {},
    showUnitModal: false,
    showStoreModal: false,
    allStores: [],
    storeSelectedOption: null,
    unitSelectedOption: {},
    openToast: false,
    stelectedCategory: {},
    storeSelectedOption: null,
    productTypes: [],
    selectedType: {},
    selectedProduct: null,
    brandAbbreviation: "",
    brandName: "",
    modifiedPrice: ""
  };
  async componentDidMount() {
    this.fetchStores();
    this.fetchUserRecieptProduct();
  }

  fetchStores = async () => {
    const { data: allStores } = await axios.get(`${API_URL}/Grocers`);
    const stores = allStores.map(item => ({
      value: item.storeName,
      label: item.storeName,
      imageUrl: item.imageUrl
    }));
    const other = {
      value: "Other",
      label: "Other",
      imageUrl: ""
    };
    this.setState({ allStores: [...stores, other] });
  };

  fetchUserRecieptProduct = async () => {
    try {
      const { data } = await axios.get(
        `${API_URL}/UserReceiptProducts/${get(
          this.props,
          "match.params.id",
          ""
        )}`
      );
      console.log(data);
      this.setState({
        userReceiptProductDetail: data,
        zipCode: data.zipCode,
        selectedOption: { value: data.status, label: data.status },
        stelectedCategory: {
          value: get(data, "productCategory", ""),
          label: get(data, "productCategory", "")
        },
        selectedType: {
          value: get(data, "productType", ""),
          label: get(data, "productType", "")
        },
        storeSelectedOption: {
          value: get(data, "storeName", ""),
          label: get(data, "storeName", ""),
          imageUrl: get(data, "storeImage", "")
        },
        product: {
          value: get(data, "productCode", ""),
          label: `${get(data, "productName", "")}`,
          productName: get(data, "productName", ""),
          productCategory: get(data, "productCategory", ""),
          productImage: get(data, "productImage", ""),
          totalGs: get(data, "greenScore", "")
        },
        unitSelectedOption: {
          value:
            get(data, "quantityUnit", "") === null
              ? "ct"
              : get(data, "quantityUnit", ""),
          label:
            get(data, "quantityUnit", "") === null
              ? "ct"
              : get(data, "quantityUnit", "")
        }
      });
    } catch (error) {
      console.log(error);
    }
  };

  async fetchAsyncProductsData(value) {
    if (value) {
      try {
        if (
          this.state.stelectedCategory.value !== "" &&
          this.state.stelectedCategory.value !== null &&
          this.state.selectedType.value !== "" &&
          this.state.selectedType.value !== null
        ) {
          var query = {
            filter: {
              where: {
                and: [
                  {
                    productCategory: this.state.stelectedCategory.value,
                    productType: this.state.selectedType.value
                  }
                ],
                or: [{ productName: { like: "%" + value + "%" } }]
              }
            }
          };
        } else if (
          this.state.stelectedCategory.value !== "" &&
          this.state.stelectedCategory.value !== null
        ) {
          var query = {
            filter: {
              where: {
                and: [
                  {
                    productCategory: this.state.stelectedCategory.value
                  }
                ],
                or: [{ productName: { like: "%" + value + "%" } }]
              }
            }
          };
        } else if (
          this.state.selectedType.value !== "" &&
          this.state.selectedType.value !== null
        ) {
          var query = {
            filter: {
              where: {
                and: [
                  {
                    productType: this.state.selectedType.value
                  }
                ],
                or: [{ productName: { like: "%" + value + "%" } }]
              }
            }
          };
        } else {
          var query = {
            filter: {
              where: {
                or: [{ productName: { like: "%" + value + "%" } }]
              }
            }
          };
        }

        const { data } = await axios.get(`${API_URL}/ProductTableMergeds`, {
          params: { filter: query.filter }
        });
        this.setState({ products: data });
      } catch (error) {
        console.log("ERROR", error);
      }
    }
    return this.state.products;
  }
  loadProducts = async inputValue => {
    try {
      let newData = [];
      newData = await this.fetchAsyncProductsData(inputValue);
      console.log(inputValue);
      console.log(newData);
      if (get(this.state, "storeSelectedOption.value", "") !== "") {
        const stores = get(this.state, "allStores", []).map(
          item => item.storeName
        );
        if (stores.includes(get(this.state, "storeSelectedOption.value", ""))) {
          newData = newData.filter(item => {
            const check = values(
              JSON.parse(get(item, "productCost", "{}"))
            ).filter(
              n =>
                n.storeName === get(this.storeSelectedOption, "store.value", "")
            );
            return check.length > 0 ? true : false;
          });
        }
      }
      return newData.map(item => ({
        value: item.productCode,
        label: `${item.productName} ${item.productQuantity} ${item.totalGs}`,
        productName: item.productName,
        productCategory: item.productCategory,
        productImage: item.productImage,
        totalGs: item.totalGs
        // productCost: JSON.parse(get(item, "productCost", "{}"))
      }));
    } catch (err) {
      console.log(err);
    }
  };

  async fetchAsyncStoresData(value) {
    const query = {
      filter: {
        where: {
          storeName: {
            like: "%" + value + "%"
          }
        }
      }
    };
    if (value) {
      try {
        const { data } = await axios.get(`${API_URL}/Grocers`, {
          params: { filter: query.filter }
        });
        this.setState({ stores: data });
      } catch (error) {
        console.log("ERROR", error);
      }
    }
    return this.state.stores;
  }

  loadStores = async inputValue => {
    try {
      const newData = await this.fetchAsyncStoresData(inputValue);
      const mappedData = newData.map(item => ({
        value: item.storeName,
        label: item.storeName,
        imageUrl: item.imageUrl
      }));

      return mappedData;
    } catch (err) {
      console.log(err);
    }
  };

  fetchProductCostDataByStore = async () => {
    if (get(this.state, "storeSelectedOption.value", "")) {
      const data = values(get(this.state, "product.productCost", {})).filter(
        item =>
          item.storeName === get(this.state, "storeSelectedOption.value", "")
      );
      this.setState({
        productPriceOriginal: get(data, "0.productPriceSale", "")
          ? get(data, "0.productPriceSale", "")
          : get(data, "0.productPriceOriginal", "")
      });
    }
  };

  fetchProductCostData = async () => {
    const data = values(get(this.state, "product.productCost", {})).filter(
      item =>
        item.storeName === get(this.state, "storeSelectedOption.value", "")
    );
    this.setState({
      productPriceOriginal: get(data, "0.productPriceSale", "")
        ? get(data, "0.productPriceSale", "")
        : get(data, "0.productPriceOriginal", "")
    });
  };

  handleChangeTypes = selectedType => {
    if (get(selectedType, "value", "") === "All") {
      var types = [];
      this.state.productTypes.map(data => {
        types.push(data.value);
      });
      types.pop();
      var select = { label: "All", value: types.toString() };
      this.setState({ selectedType: select });
    } else {
      this.setState({
        selectedType: selectedType
      });
    }
  };

  handleChange = selectedOption => {
    this.setState({ selectedOption: selectedOption });
  };

  handleClose = async () => {
    await this.setState({ openToast: false });
  };

  handleChangeUnit = unitSelectedOption => {
    this.setState({
      unitSelectedOption: unitSelectedOption,
      showUnitModal:
        get(unitSelectedOption, "value", "") === "other" ? true : false
    });
  };

  handleChangeStore = storeSelectedOption => {
    if (get(storeSelectedOption, "value", "") === "Other") {
      this.setState({
        storeSelectedOption: storeSelectedOption,
        showStoreModal: true
      });
    } else {
      this.setState({ storeSelectedOption: storeSelectedOption });
      this.fetchProductCostDataByStore();
    }
  };

  handleChangeCategory = async stelectedCategory => {
    this.setState({
      stelectedCategory: stelectedCategory,
      selectedType: { value: "", label: "All" }
    });
    await this.fetchProductType(
      stelectedCategory.value,
      stelectedCategory.name
    );
  };

  async fetchProductType(value, name) {
    if (value) {
      try {
        const { data: productTypes } = await axios.post(
          `${API_URL}/ProductTableMergeds/getProductTypes`,
          {
            productCategory: value
          }
        );
        const stores = productTypes.map(item => ({
          value: item,
          label: item
        }));
        const other = {
          value: "",
          label: "All"
        };
        this.setState({ productTypes: [...stores, other] });
      } catch (error) {
        console.log("ERROR", error);
      }
    }
    return this.state.productTypes;
  }
  render() {
    const {
      selectedOption,
      isLoading,
      productPriceOriginal,
      userReceiptProductDetail,
      storeSelectedOption,
      unitSelectedOption,
      showUnitModal,
      showStoreModal,
      stelectedCategory,
      selectedType,
      openToast
    } = this.state;
    return (
      <React.Fragment>
        <Header
          icon="arrowBack"
          title="Update Purchase Products"
          onClickBack={() => this.props.history.goBack()}
          backgroundColor="#124b5f"
          color="#fff"
        />
        <PageWrapper
          viewPadding="0 20px"
          height={"calc(100% - 0px)"}
          modifyPadding="0 20px"
          style={{ paddingTop: 60 }}
        >
          <Formik
            enableReinitialize
            initialValues={{
              zipCode: get(userReceiptProductDetail, "zipCode", "") || "",
              originalPrice:
                productPriceOriginal ||
                get(userReceiptProductDetail, "originalPrice", "") ||
                "",
              modifiedPrice:
                get(userReceiptProductDetail, "modifiedPrice", "") || "",
              //   === 0 ? '0' : get(userReceiptProductDetail, 'modifiedPrice', '0')
              quantity: get(userReceiptProductDetail, "quantity", "") || "",
              product: "",
              brandAbbreviation:
                get(userReceiptProductDetail, "brandAbbreviation", "") || "",
              brandName: get(userReceiptProductDetail, "brandName", "") || "",
              store: "",
              status: "",
              listName: get(userReceiptProductDetail, "listName", "") || ""
            }}
            onSubmit={async val => {
              this.setState({ isLoading: true, openToast: true });
              await axios.patch(
                `${API_URL}/UserReceiptProducts/${get(
                  this.props,
                  "match.params.id",
                  ""
                )}`,
                {
                  zipCode: get(this.state, "zipCode", null),
                  originalPrice: get(val, "modifiedPrice", null),
                  modifiedPrice: get(val, "modifiedPrice", null),
                  quantity: get(val, "quantity", null),
                  //zipCode: get(this.state, 'zipCode', null),
                  productType: get(this.state, "selectedType.value", null),
                  brandAbbreviation: get(val, "brandAbbreviation", null),
                  brandName: get(val, "brandName", null),
                  greenScore: get(this.state, "product.totalGs", null),
                  productCode: get(this.state, "product.value", null),
                  productImage: get(this.state, "product.productImage", null),
                  productName: get(this.state, "product.productName", null),
                  productCategory: get(
                    this.state,
                    "stelectedCategory.value",
                    null
                  ),
                  storeName: get(this.state, "storeSelectedOption.value", null),
                  status: get(this.state, "selectedOption.value", null),
                  storeImage: get(
                    this.state,
                    "storeSelectedOption.imageUrl",
                    null
                  ),
                  listName: get(val, "listName", null),
                  quantityUnit: get(
                    this.state,
                    "unitSelectedOption.value",
                    null
                  )
                }
              );
              await axios.post(
                `${API_URL}/UserReceipts/calculateReferral/${get(
                  this.state,
                  "userReceiptProductDetail.userReceiptId",
                  ""
                )}`
              );
              if (
                get(this.state, "selectedOption.value", null) === "Approved"
              ) {
                const q = {
                  filter: {
                    where: {
                      referralType: "Purchase",
                      referralDescription: get(
                        this.state,
                        "userReceiptProductDetail.userReceiptId",
                        ""
                      )
                    }
                  }
                };
                const {
                  data: referral
                } = await axios.get(`${API_URL}/Referrals`, {
                  params: { filter: q.filter }
                });
                await axios.patch(
                  `${API_URL}/Referrals/${get(referral, "0.id", "")}`,
                  {
                    status: "Approved"
                  }
                );
              }
              console.log(
                this.state,
                "userReceiptProductDetail.userReceiptId",
                ""
              );
              console.log(this.props.history);
              this.props.history.push(
                `/view-purchased-automation-native/${get(
                  this.state,
                  "userReceiptProductDetail.userReceiptId",
                  ""
                )}`
              );
              this.setState({ isLoading: false });
            }}
            render={formikBag => (
              <FormikForm
                style={{
                  justifyContent: "space-between",
                  overflowX: "scroll",
                  padding: "0 20px",
                  border: "2px solid"
                }}
              >
                <XXLText style={{ marginTop: 30 }}>
                  Update Purchased Products
                </XXLText>
                <Field
                  name="zipCode"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      value={this.state.zipCode}
                      label="ZipCode"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                      onChange={zipCode => {
                        this.setState({ zipCode: zipCode.target.value });
                      }}
                    />
                  )}
                />
                <div>
                  <label
                    style={{ display: "block", padding: "0 10px 5px 10px" }}
                  >
                    Select Store
                  </label>
                  <Field
                    name="store"
                    placeholder="Select store"
                    render={({ field }) => (
                      <SelectBox
                        paddingBottom="10px"
                        name="store"
                        options={this.state.allStores}
                        value={storeSelectedOption}
                        onChange={this.handleChangeStore}
                        selectField
                      />
                    )}
                  />
                </div>
                <div>
                  <label
                    style={{ display: "block", padding: "0 10px 5px 10px" }}
                  >
                    Product Category
                  </label>
                  <Field
                    name="category"
                    placeholder="Product Category"
                    render={({ field }) => (
                      <SelectBox
                        paddingBottom="10px"
                        name="category"
                        options={[
                          { value: "", label: "All" },
                          { value: "pantry", label: "pantry" },
                          { value: "beverages", label: "beverages" },
                          {
                            value: "breads and bakery",
                            label: "breads and bakery"
                          },
                          { value: "dairy and eggs", label: "dairy and eggs" },
                          { value: "meat", label: "meat" },
                          { value: "frozen foods", label: "frozen foods" },
                          {
                            value: "snacks and dips",
                            label: "snacks and dips"
                          },
                          { value: "prepared food", label: "prepared food" },
                          { value: "produce", label: "produce" },
                          { value: "seafood", label: "seafood" }
                        ]}
                        value={stelectedCategory}
                        onChange={this.handleChangeCategory}
                        selectField
                      />
                    )}
                  />
                </div>
                <div>
                  <label
                    style={{ display: "block", padding: "0 10px 5px 10px" }}
                  >
                    Product Type
                  </label>
                  <Field
                    name="type"
                    placeholder="Product Type"
                    render={({ field }) => (
                      <SelectBox
                        paddingBottom="10px"
                        name="type"
                        options={this.state.productTypes}
                        value={selectedType}
                        onChange={this.handleChangeTypes}
                        selectField
                      />
                    )}
                  />
                </div>

                <Field
                  name="product"
                  render={({ field }) => (
                    <SelectBox
                      // cacheOptions
                      paddingBottom="10px"
                      isClearable={true}
                      defaultOptions={true}
                      loadOptions={this.loadProducts}
                      isSelected
                      value={get(this.state, "product", "")}
                      placeholder="Search Product"
                      onChange={product => {
                        this.setState({ product }, () => {
                          this.fetchProductCostData();
                        });
                      }}
                    />
                  )}
                />
                <Field
                  name="brandAbbreviation"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Brand Abbreviation"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      style={{ zIndex: 0 }}
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Field
                  name="brandName"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Brand Name"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      style={{ zIndex: 0 }}
                      fontColor="#124b5f"
                    />
                  )}
                />
                {/* <Field
                  name="originalPrice"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Original Price"
                      style={{ zIndex: 0 }}
                      margin="30px 14px"
                      width="auto"
                      required
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                /> */}
                <Field
                  name="modifiedPrice"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="number"
                      label="Product Price"
                      margin="30px 14px"
                      width="auto"
                      style={{ zIndex: 0 }}
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Field
                  name="quantity"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="Quantity"
                      margin="30px 14px"
                      width="auto"
                      required
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <Field
                  name="listName"
                  render={({ field }) => (
                    <TextField
                      {...field}
                      type="text"
                      label="List Name"
                      margin="30px 14px"
                      width="auto"
                      fontSize="18px"
                      fontColor="#124b5f"
                    />
                  )}
                />
                <div>
                  <label
                    style={{ display: "block", padding: "0 10px 5px 10px" }}
                  >
                    Select Quantity Unit
                  </label>
                  <Field
                    name="unit"
                    placeholder="Select Unit"
                    render={({ field }) => (
                      <SelectBox
                        paddingBottom="10px"
                        name="unit"
                        options={[
                          { value: "oz", label: "oz" },
                          { value: "fl oz", label: "fl oz" },
                          { value: "pt", label: "pt" },
                          { value: "gallon", label: "gallon" },
                          { value: "pk", label: "pk" },
                          { value: "ct", label: "ct" },
                          { value: "lb", label: "lb" },
                          { value: "other", label: "other" }
                        ]}
                        value={unitSelectedOption}
                        onChange={this.handleChangeUnit}
                        selectField
                      />
                    )}
                  />
                </div>

                <div>
                  <label
                    style={{ display: "block", padding: "0 10px 5px 10px" }}
                  >
                    Select Status
                  </label>
                  <Field
                    name="status"
                    render={({ field }) => (
                      <SelectBox
                        paddingBottom="10px"
                        name="status"
                        options={[
                          { value: "Pending", label: "Pending" },
                          { value: "Approved", label: "Approved" },
                          { value: "Reject", label: "Reject" }
                        ]}
                        value={selectedOption}
                        onChange={this.handleChange}
                        selectField
                      />
                    )}
                  />
                </div>
                <Toast
                  open={openToast}
                  message="Product Successfully Updated!"
                  onClose={this.handleClose}
                />
                <div>
                  <Button
                    style={{ lineHeight: 2.4, marginBottom: 20 }}
                    volume="filled"
                    type="submit"
                    label="Update"
                    disabled={isLoading}
                    isLoading={isLoading}
                  />
                </div>
              </FormikForm>
            )}
          />
        </PageWrapper>{" "}
        <Modal
          title={"Enter Unit Name"}
          show={showUnitModal}
          hide={!showUnitModal}
          maxWidth="648px"
          onClose={() => this.setState({ showUnitModal: false })}
        >
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={{ unitName: "" }}
              validateOnChange
              onSubmit={val => {
                this.setState({
                  unitSelectedOption: {
                    value: val.unitName,
                    label: val.unitName
                  },
                  showUnitModal: false
                });
              }}
              render={formikBag => (
                <FormikForm>
                  <Field
                    name="unitName"
                    render={({ field }) => (
                      <FlexWrapper height="100%">
                        <Field
                          name="unitName"
                          render={({ field }) => (
                            <TextField
                              {...field}
                              width="calc(100% - 40px)"
                              paddingTop="10px"
                              type="text"
                              fontColor="#124b5f"
                              viewPadding="10px 14px 0"
                              hideEye
                              label="Enter Unit Name"
                              margin="30px 0"
                              fontSize="18px"
                              required
                            />
                          )}
                        />
                      </FlexWrapper>
                    )}
                  />

                  <Button
                    padding="10px 20px"
                    height="42px"
                    fontSize="15px"
                    size="small"
                    volume="filled"
                    type="submit"
                    label="Submit"
                    disabled={this.state.isLoading}
                    isLoading={this.state.isLoading}
                  />
                </FormikForm>
              )}
            />
          </React.Fragment>
        </Modal>
        <Modal
          title={"Enter Store Name"}
          show={showStoreModal}
          hide={!showStoreModal}
          maxWidth="648px"
          onClose={() => this.setState({ showStoreModal: false })}
        >
          <React.Fragment>
            <Formik
              enableReinitialize
              initialValues={{ storeName: "" }}
              validateOnChange
              onSubmit={val => {
                this.setState({
                  storeSelectedOption: {
                    value: val.storeName,
                    label: val.storeName
                  },
                  showStoreModal: false
                });
              }}
              render={formikBag => (
                <FormikForm>
                  <Field
                    name="storeName"
                    render={({ field }) => (
                      <FlexWrapper height="100%">
                        <Field
                          name="storeName"
                          render={({ field }) => (
                            <TextField
                              {...field}
                              width="calc(100% - 40px)"
                              paddingTop="10px"
                              type="text"
                              fontColor="#124b5f"
                              viewPadding="10px 14px 0"
                              hideEye
                              label="Enter Store Name"
                              margin="30px 0"
                              fontSize="18px"
                              required
                            />
                          )}
                        />
                      </FlexWrapper>
                    )}
                  />

                  <Button
                    padding="10px 20px"
                    height="42px"
                    fontSize="15px"
                    size="small"
                    volume="filled"
                    type="submit"
                    label="Submit"
                    disabled={this.state.isLoading}
                    isLoading={this.state.isLoading}
                  />
                </FormikForm>
              )}
            />
          </React.Fragment>
        </Modal>
      </React.Fragment>
    );
  }
}
export default UpdatePurchaseProducts;



// WEBPACK FOOTER //
// ./src/pages/UpdatePurchaseProducts.js